var _defs, _rect, _path, _path2, _circle, _rect2, _rect3, _circle2, _rect4, _rect5, _path3, _rect6, _rect7, _rect8, _rect9, _rect0, _rect1, _path4, _rect10, _rect11, _circle3, _circle4, _path5, _path6, _path7, _circle5, _circle6, _rect12, _path8, _path9, _circle7, _circle8, _path0, _path1, _path10, _circle9, _circle0, _rect13, _path11, _path12, _circle1, _circle10, _rect14, _path13, _path14, _circle11, _circle12, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _ellipse, _ellipse2, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _g, _path34, _path35, _path36, _rect15, _path37, _path38, _path39, _path40, _circle13, _circle14, _path41, _rect16, _rect17, _circle15, _circle16, _rect18, _rect19, _rect20, _circle17, _circle18, _path42, _rect21, _rect22, _circle19, _circle20, _rect23, _rect24, _rect25, _circle21, _circle22, _rect26, _rect27, _rect28, _circle23, _circle24, _path43, _path44, _path45, _path46, _rect29, _circle25, _path47, _path48, _rect30, _rect31, _rect32, _rect33, _rect34, _rect35, _path49, _path50, _path51, _path52, _path53, _rect36, _rect37, _rect38, _rect39, _rect40, _rect41, _rect42, _rect43, _rect44, _circle26, _rect45, _rect46, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIllustratieContact({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 711.84386 321.78565",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1, .cls-15 {\n        fill: none;\n      }\n\n      .cls-2 {\n        fill: #e3e3e3;\n      }\n\n      .cls-3 {\n        fill: #919191;\n      }\n\n      .cls-4 {\n        fill: #f8f8f8;\n      }\n\n      .cls-5 {\n        fill: #fff;\n      }\n\n      .cls-6 {\n        fill: #f2f2f2;\n      }\n\n      .cls-7 {\n        fill: #454545;\n      }\n\n      .cls-8 {\n        fill: #b28b67;\n      }\n\n      .cls-9 {\n        fill: #191847;\n      }\n\n      .cls-10 {\n        fill: #d8d8d8;\n      }\n\n      .cls-11 {\n        fill: #c72f18;\n      }\n\n      .cls-12 {\n        fill: #dde3e9;\n      }\n\n      .cls-13 {\n        fill: #f04e36;\n      }\n\n      .cls-14 {\n        fill: #66c3ec;\n      }\n\n      .cls-15 {\n        stroke: #454545;\n        stroke-miterlimit: 10;\n      }\n\n      .cls-16 {\n        fill: #757575;\n      }\n\n      .cls-17 {\n        clip-path: url(#clip-path);\n      }\n\n      .cls-18 {\n        fill: #bbd773;\n      }\n\n      .cls-19 {\n        isolation: isolate;\n        opacity: 0.15;\n      }\n\n      .cls-20 {\n        fill: #79c48e;\n      }\n\n      .cls-21 {\n        fill: #325ca7;\n      }\n\n      .cls-22 {\n        fill: #b14196;\n      }\n\n      .cls-23 {\n        fill: #2f3676;\n      }\n\n      .cls-24 {\n        fill: #e0c1a4;\n      }\n\n      .cls-25 {\n        fill: #987f51;\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M648.191,220.31111a55.75394,55.75394,0,0,1-71.31372,33.63574l-.00226-.00073a55.75409,55.75409,0,1,1,37.676-104.95044l.001.00049a55.73933,55.73933,0,0,1,33.639,71.31494Z"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Photo_Background",
    "data-name": "Photo Background",
    className: "cls-2",
    x: 513.442,
    y: 129.511,
    width: 61.972,
    height: 41.097,
    rx: 4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Mountains",
    className: "cls-3",
    d: "M536.926,141.255,518.661,170.61h36.531Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Mountains-2",
    className: "cls-4",
    d: "M554.866,149.083,538.884,170.61h31.965Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Sun",
    className: "cls-5",
    cx: 561.71602,
    cy: 143.21,
    r: 5.871
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "Container",
    className: "cls-6",
    x: 242.49913,
    y: 119.00029,
    width: 170.44299,
    height: 176.039,
    rx: 8
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    id: "Background",
    className: "cls-4",
    x: 369.18614,
    y: 140.87724,
    width: 35.615,
    height: 41.211,
    rx: 8
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    id: "Avatar",
    className: "cls-2",
    cx: 386.99413,
    cy: 156.65106,
    r: 8.141
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    id: "Name",
    className: "cls-2",
    x: 374.27403,
    y: 166.82646,
    width: 25.439,
    height: 3.053,
    rx: 1.526
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    id: "Name-2",
    className: "cls-2",
    x: 378.34386,
    y: 171.91435,
    width: 17.299,
    height: 3.053,
    rx: 1.526
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Header",
    className: "cls-7",
    d: "M250.49913,119.00029h154.443a8,8,0,0,1,8,8v5.737h-170.443v-5.737A8,8,0,0,1,250.49913,119.00029Z"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    id: "Background-2",
    className: "cls-4",
    x: 369.18614,
    y: 186.16045,
    width: 35.615,
    height: 98.704,
    rx: 8
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    id: "Data",
    className: "cls-2",
    x: 378.34386,
    y: 195.31865,
    width: 17.299,
    height: 13.228,
    rx: 4
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    id: "Data-2",
    className: "cls-2",
    x: 378.34386,
    y: 212.61765,
    width: 17.299,
    height: 12.72,
    rx: 4
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    id: "Data-3",
    className: "cls-2",
    x: 378.34386,
    y: 229.40765,
    width: 17.299,
    height: 12.72,
    rx: 4
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    id: "Data-4",
    className: "cls-2",
    x: 378.34386,
    y: 262.98665,
    width: 17.299,
    height: 12.72,
    rx: 4
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    id: "Data-5",
    className: "cls-2",
    x: 378.34386,
    y: 246.19665,
    width: 17.299,
    height: 12.72,
    rx: 4
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Container-2",
    className: "cls-4",
    d: "M252.67476,141.387h110.406a2.035,2.035,0,0,1,2.035,2.035h0v19.843a2.035,2.035,0,0,1-2.035,2.035h-110.406a2.035,2.035,0,0,1-2.035-2.035V143.422a2.035,2.035,0,0,1,2.035-2.035Z"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    id: "Label",
    className: "cls-2",
    x: 255.21876,
    y: 148.56101,
    width: 84.967,
    height: 3.587,
    rx: 1.793
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    id: "Label-2",
    className: "cls-2",
    x: 255.21876,
    y: 154.53901,
    width: 57.033,
    height: 3.587,
    rx: 1.793
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    id: "Background-3",
    className: "cls-2",
    cx: 352.88176,
    cy: 153.34301,
    r: 3.561
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    id: "Indicator",
    className: "cls-2",
    cx: 352.88176,
    cy: 153.34301,
    r: 1.526
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Container-3",
    className: "cls-4",
    d: "M252.67476,169.36943h110.406a2.035,2.035,0,0,1,2.035,2.035h0v15.772a2.035,2.035,0,0,1-2.035,2.035h-110.406a2.035,2.035,0,0,1-2.035-2.035v-15.772a2.035,2.035,0,0,1,2.035-2.035Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Label-3",
    className: "cls-2",
    d: "M256.70676,175.32243h81.991a1.488,1.488,0,0,1,1.488,1.488h0a1.488,1.488,0,0,1-1.488,1.488h-81.991a1.488,1.488,0,0,1-1.488-1.488h0A1.488,1.488,0,0,1,256.70676,175.32243Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Label-4",
    className: "cls-2",
    d: "M256.70676,180.28343h54.057a1.488,1.488,0,0,1,1.488,1.488h0a1.488,1.488,0,0,1-1.488,1.488h-54.057a1.488,1.488,0,0,1-1.488-1.488h0A1.488,1.488,0,0,1,256.70676,180.28343Z"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    id: "Background-4",
    className: "cls-2",
    cx: 352.88176,
    cy: 179.29043,
    r: 3.561
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    id: "Indicator-2",
    className: "cls-2",
    cx: 352.88176,
    cy: 179.29043,
    r: 1.526
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    id: "Container-4",
    className: "cls-4",
    x: 250.63976,
    y: 193.28349,
    width: 114.476,
    height: 19.843,
    rx: 4
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Label-5",
    className: "cls-2",
    d: "M256.70676,199.23649h81.991a1.488,1.488,0,0,1,1.488,1.488h0a1.488,1.488,0,0,1-1.488,1.488h-81.991a1.488,1.488,0,0,1-1.488-1.488h0A1.488,1.488,0,0,1,256.70676,199.23649Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Label-6",
    className: "cls-2",
    d: "M256.70676,204.19749h54.057a1.488,1.488,0,0,1,1.488,1.488h0a1.488,1.488,0,0,1-1.488,1.488h-54.057a1.488,1.488,0,0,1-1.488-1.488h0A1.488,1.488,0,0,1,256.70676,204.19749Z"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    id: "Background-5",
    className: "cls-2",
    cx: 352.88176,
    cy: 203.20449,
    r: 3.561
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    id: "Indicator-3",
    className: "cls-2",
    cx: 352.88176,
    cy: 203.20449,
    r: 1.526
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    id: "Container-5",
    className: "cls-4",
    d: "M252.67476,265.02177h110.406a2.035,2.035,0,0,1,2.035,2.035h0v15.772a2.035,2.035,0,0,1-2.035,2.035h-110.406a2.035,2.035,0,0,1-2.035-2.035v-15.772a2.035,2.035,0,0,1,2.035-2.035Z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    id: "Label-7",
    className: "cls-2",
    d: "M256.70676,270.97477h81.991a1.488,1.488,0,0,1,1.488,1.488h0a1.488,1.488,0,0,1-1.488,1.488h-81.991a1.488,1.488,0,0,1-1.488-1.488h0A1.488,1.488,0,0,1,256.70676,270.97477Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Label-8",
    className: "cls-2",
    d: "M256.70676,275.93577h54.057a1.488,1.488,0,0,1,1.488,1.488h0a1.488,1.488,0,0,1-1.488,1.488h-54.057a1.488,1.488,0,0,1-1.488-1.488h0A1.488,1.488,0,0,1,256.70676,275.93577Z"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    id: "Background-6",
    className: "cls-2",
    cx: 352.88176,
    cy: 274.94277,
    r: 3.561
  })), _circle0 || (_circle0 = /*#__PURE__*/React.createElement("circle", {
    id: "Indicator-4",
    className: "cls-2",
    cx: 352.88176,
    cy: 274.94277,
    r: 1.526
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    id: "Container-6",
    className: "cls-4",
    x: 250.63976,
    y: 241.10771,
    width: 114.476,
    height: 19.843,
    rx: 4
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Label-9",
    className: "cls-2",
    d: "M256.70676,247.06071h81.991a1.488,1.488,0,0,1,1.488,1.488h0a1.488,1.488,0,0,1-1.488,1.488h-81.991a1.488,1.488,0,0,1-1.488-1.488h0A1.488,1.488,0,0,1,256.70676,247.06071Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Label-10",
    className: "cls-2",
    d: "M256.70676,252.02171h54.057a1.488,1.488,0,0,1,1.488,1.488h0a1.488,1.488,0,0,1-1.488,1.488h-54.057a1.488,1.488,0,0,1-1.488-1.488h0A1.488,1.488,0,0,1,256.70676,252.02171Z"
  })), _circle1 || (_circle1 = /*#__PURE__*/React.createElement("circle", {
    id: "Background-7",
    className: "cls-2",
    cx: 352.88176,
    cy: 251.02871,
    r: 3.561
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    id: "Indicator-5",
    className: "cls-2",
    cx: 352.88176,
    cy: 251.02871,
    r: 1.526
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    id: "Container-7",
    className: "cls-4",
    x: 250.63976,
    y: 217.1956,
    width: 114.476,
    height: 19.843,
    rx: 4
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Label-11",
    className: "cls-2",
    d: "M256.70676,223.1486h81.991a1.488,1.488,0,0,1,1.488,1.488h0a1.488,1.488,0,0,1-1.488,1.488h-81.991a1.488,1.488,0,0,1-1.488-1.488h0A1.488,1.488,0,0,1,256.70676,223.1486Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "Label-12",
    className: "cls-2",
    d: "M256.70676,228.1096h54.057a1.488,1.488,0,0,1,1.488,1.488h0a1.488,1.488,0,0,1-1.488,1.488h-54.057a1.488,1.488,0,0,1-1.488-1.488h0A1.488,1.488,0,0,1,256.70676,228.1096Z"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    id: "Background-8",
    className: "cls-2",
    cx: 352.88176,
    cy: 227.1166,
    r: 3.561
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    id: "Indicator-6",
    className: "cls-2",
    cx: 352.88176,
    cy: 227.1166,
    r: 1.526
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "Path_584",
    "data-name": "Path 584",
    className: "cls-5",
    d: "M332.20909,128.92226h-2.966v-.45h2.966Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "Path_585",
    "data-name": "Path 585",
    className: "cls-5",
    d: "M321.69309,128.04526v-1.886h-1.257v1.886h-.706v-4.252h.706v1.724h1.258v-1.724h.706v4.252Z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "Path_586",
    "data-name": "Path 586",
    className: "cls-5",
    d: "M328.04409,128.04526l-1.192-3h-.018l.012,3h-.64v-4.252h.813l1.181,3.021h.018l-.006-3.021h.617v4.252Z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    id: "Path_587",
    "data-name": "Path 587",
    className: "cls-5",
    d: "M324.80509,123.79326h-.884l-.7,2.854-.59.2.185.557.238-.081-.178.721h.646l.237-.961,1.118-.38.33,1.341h.646Zm-.881,2.614.418-1.7h.042l.35,1.422Z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    id: "Head-2",
    className: "cls-8",
    d: "M435.74216,175.11572l5.76148-18.7257a13.47624,13.47624,0,0,1-2.72816-9.95716c1.67039-10.54042,16.22926-6.91728,18.63328-1.315s.87632,19.151-2.9183,19.783c-1.51337.25218-4.58511-.95751-7.625-3.175l.76994,14.42876Z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    id: "Hair",
    className: "cls-9",
    d: "M446.99569,161.154c-.586-2.4829-.28577-9.45879-.18043-11.515a3.016,3.016,0,0,0-.35474-.05206,2.98437,2.98437,0,0,0-2.52318,4.919c-.77307.911-1.63262,1.85857-2.60742,2.82721-3.14459-2.28289-5.09866-8.32563-1.36449-13.6427a7.37046,7.37046,0,0,1,5.75261-4.42317,8.66015,8.66015,0,0,1,5.69862.07826,18.49614,18.49614,0,0,1,6.99455,2.53387c-.276,3.15931-.97037,4.043-6.19115,3.50371a9.681,9.681,0,0,0-3.59585,3.09011c-.00173.10021-.13374,9.5737,2.78155,9.82835,2.93023.256,5.57777-1.38751,6.86361-1.27519.93723.08186.62559,1.23688-.07178,2.0511-.57558.67232-3.131,1.14661-3.22812,2.25814-.05481.62748.57367.68238,1.12164.72824.42231.03688.7968.0696.77183.35545-.0957,1.0956.07212,3.17266-1.82127,3.00727C453.12338,165.259,447.69043,164.08092,446.99569,161.154Z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    id: "Path_558",
    "data-name": "Path 558",
    className: "cls-10",
    d: "M433.233,231.27212c22.254,0,40.3,28.478,40.3,63.613h-80.59C392.942,259.74892,410.983,231.27212,433.233,231.27212Z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    id: "Path_559",
    "data-name": "Path 559",
    className: "cls-11",
    d: "M444.675,180.779s19.435-.59106,26.219-6.42212-1.672-21.97-1.672-21.97H458.944s4.013,9.52295,1.206,14.21607-13.35-.8-13.35-.8Z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    id: "Shirt",
    className: "cls-12",
    d: "M439.962,164.80312l10.341,1.62207c0,19.61206,3.969,41.16309,6.7,54.94092.238,1.19409.547,3.561-1.094,3.561l-28.557-1.782C429.043,200.42007,431.406,178.559,439.962,164.80312Z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    id: "Coat_Front",
    "data-name": "Coat Front",
    className: "cls-13",
    d: "M423.183,204.277a117.93992,117.93992,0,0,0-4.391,23.791h32.276c6.247-15.78809-7.678-63.26392-7.678-63.26392h-4.1C429.302,179.14907,426.224,191.14907,423.183,204.277Z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    id: "Path_560",
    "data-name": "Path 560",
    className: "cls-7",
    d: "M455.095,150.296l34.541-5.91089v12.981l-34.541-3.825Z"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-14",
    cx: 489.636,
    cy: 150.876,
    rx: 2.922,
    ry: 6.491
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-15",
    cx: 489.636,
    cy: 150.876,
    rx: 2.422,
    ry: 5.991
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    id: "Path_561",
    "data-name": "Path 561",
    className: "cls-8",
    d: "M461.891,146.442c3.553-1.56909,7.55-.7,7.928,2.425s-2.113,6.22192-1.247,13.594l-5.866,1.322a28.57442,28.57442,0,0,0-.162-8.97094C462.01,152.194,458.341,148.007,461.891,146.442Z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    id: "Path_562",
    "data-name": "Path 562",
    className: "cls-13",
    d: "M444.981,183.391s17.829-.54,24.051-5.887,1.387-20.15405,1.387-20.15405h-9.428s.759,8.73511-1.813,13.03808-15.838-.01611-15.838-.01611Z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    id: "Path_563",
    "data-name": "Path 563",
    className: "cls-7",
    d: "M450.728,228.07c7.61,0,20.941,6.0249,26.092,8.366s6.909,6.67089,8.2,13.229,3.672,35.281,3.672,35.281l-8.144,1.28906s-6.122-19.15088-8.11-24.77-10.666-9.80689-10.666-9.80689l-9.088-10.57788Z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    id: "Path_564",
    "data-name": "Path 564",
    className: "cls-16",
    d: "M418.824,228.07c0,7.02588-1.806,14.353,5.744,18.041s25.595,2.582,25.595,2.582l-20.748,10.6101,2.341,7.72705s24.357-6.22509,42.389-13.606-1.756-15.813-8.432-18.856-14.985-6.5-14.985-6.5Z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    id: "Shoe",
    d: "M422.612,265.05106l.872-.343,1.359,6.01294,6.519,16.573,1.744-.689s-1.294-11.606.722-19.92212l-3.6-9.15991-9.328,3.16895Z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    id: "Shoe-2",
    d: "M484.407,294.52309l-.038-.93505,6.125.675,17.791-.75708-.078-1.87109s-11.4-2.563-18.6-7.18188l-9.832.41894-.05,9.85108Z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    id: "Path_565",
    "data-name": "Path 565",
    d: "M573.543,265.463a2.248,2.248,0,0,0,2.119-1.491L619.823,140.965a2.24888,2.24888,0,0,0-1.35492-2.87744l-.00109-.00049a2.25,2.25,0,0,0-2.878,1.35693L571.425,262.4501a2.25008,2.25008,0,0,0,1.35694,2.87817l.00207.00073A2.22925,2.22925,0,0,0,573.543,265.463Z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    id: "Path_566",
    "data-name": "Path 566",
    className: "cls-14",
    d: "M648.19,220.31216a55.754,55.754,0,0,1-71.31372,33.63574l-.00226-.00073A55.75409,55.75409,0,1,1,614.55,148.99673l.001.00049a55.73933,55.73933,0,0,1,33.639,71.31494Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-17"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2983",
    "data-name": "Rectangle 2983",
    className: "cls-18",
    x: 637.78277,
    y: 153.83767,
    width: 12.89723,
    height: 39.13662,
    rx: 2.06372,
    transform: "translate(263.25376 721.0918) rotate(-70.2421)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_567",
    "data-name": "Path 567",
    className: "cls-18",
    d: "M694.902,227.4261a15.29991,15.29991,0,0,0-9.759-18.3999l-52.868-18.979a15.319,15.319,0,0,0-19.376,8.25,15.04293,15.04293,0,0,0,8.139,19.65552q.33381.13843.674.2605l12.632,4.53491a1.874,1.874,0,0,1,1.12873,2.398l-.00074.00195h0a1.87109,1.87109,0,0,1-2.39346,1.12818l-.00055-.00025-5.066-1.81909a7.867,7.867,0,0,0-10.06259,4.74585l-.0004.00122h0a7.865,7.865,0,0,0,4.74213,10.06128l.00488.00171,46.883,16.832a7.87,7.87,0,0,0,10.066-4.74292h0a7.87021,7.87021,0,0,0-4.74683-10.06689H674.898l1.278-3.562a15.03108,15.03108,0,0,0,18.68049-10.144Q694.87964,227.50472,694.902,227.4261Z"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2984",
    "data-name": "Rectangle 2984",
    className: "cls-18",
    x: 577.22715,
    y: 221.14344,
    width: 12.14033,
    height: 29.8159,
    rx: 1.94273,
    transform: "translate(163.96079 705.2133) rotate(-70.2421)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_568",
    "data-name": "Path 568",
    className: "cls-18",
    d: "M590.815,182.78792l-14.816-5.32105a2.9489,2.9489,0,0,1-1.95-3.3999,2.83933,2.83933,0,0,1,3.719-1.9939l6.278,2.252a6.91116,6.91116,0,0,0,8.84223-4.16407l.00177-.00488h0a6.916,6.916,0,0,0-4.172-8.843L548.098,146.732a2.841,2.841,0,0,0-3.631,1.71191l-2.753,7.668a2.842,2.842,0,0,0,1.713,3.63208l6.316,2.26611a2.954,2.954,0,0,1,1.95,3.407,2.84225,2.84225,0,0,1-3.716,1.99292l-6.469-2.322a2.842,2.842,0,0,0-3.631,1.71289l-2.75,7.66894a2.82206,2.82206,0,0,0,.372,2.62207l-2.222,6.18506-4.669-1.677a6.248,6.248,0,0,0-7.782,3.02392,6.07289,6.07289,0,0,0,2.88715,8.08863q.26769.12706.54687.22729l41.014,14.7251a6.24908,6.24908,0,0,0,7.785-3.022,6.075,6.075,0,0,0-2.88745-8.09156q-.26806-.12706-.54755-.22753l-13.082-4.6941a3.039,3.039,0,0,1-1.831-3.885h0a3.03616,3.03616,0,0,1,3.88324-1.83178l.00177.00073,27.276,9.792a7.10705,7.10705,0,0,0,9.041-3.873,6.91482,6.91482,0,0,0-3.89734-8.969Q590.916,182.824,590.815,182.78792Z"
  }))), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    id: "Path_570",
    "data-name": "Path 570",
    d: "M595.652,266.76688a65.29379,65.29379,0,0,0,22.119-126.74707l-1.519,4.23706a60.78837,60.78837,0,1,1-41.083,114.425L573.65,262.919A65.00021,65.00021,0,0,0,595.652,266.76688Z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    id: "Path_571",
    "data-name": "Path 571",
    d: "M616.899,286.767c-9.116,0-18.566-14.01-18.566-21.457h-5.782c0,7.447-9.45,21.457-18.566,21.457s-9.119,8.11792-9.119,8.11792h61.152S626.018,286.767,616.899,286.767Z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    id: "Path_572",
    "data-name": "Path 572",
    className: "cls-19",
    d: "M543.24,182.62881a55.72622,55.72622,0,0,1,51.208-36.89991,55.7539,55.7539,0,0,0-12.20184,107.82154l.01483.00537a55.6037,55.6037,0,0,0,20.11,3.27588,55.75623,55.75623,0,0,1-59.131-74.20288Z"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    id: "Container-2-2",
    "data-name": "Container",
    className: "cls-6",
    x: 469.10987,
    y: 71.07364,
    width: 242.73399,
    height: 250.70399,
    rx: 8
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    id: "Header-2",
    "data-name": "Header",
    className: "cls-7",
    d: "M477.10987,71.07364h226.734a8,8,0,0,1,8,8v11.564h-242.734v-11.564A8,8,0,0,1,477.10987,71.07364Z"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    id: "Container-2-3",
    "data-name": "Container-2",
    className: "cls-4",
    d: "M483.60287,102.95564h157.232a2.9,2.9,0,0,1,2.9,2.9v28.257a2.9,2.9,0,0,1-2.9,2.9h-157.232a2.9,2.9,0,0,1-2.9-2.9v-28.257A2.9,2.9,0,0,1,483.60287,102.95564Z"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    id: "Label-2-2",
    "data-name": "Label",
    className: "cls-2",
    d: "M489.77787,113.17264h115.897a2.554,2.554,0,0,1,2.554,2.554h0a2.554,2.554,0,0,1-2.554,2.554h-115.897a2.554,2.554,0,0,1-2.554-2.554h0A2.554,2.554,0,0,1,489.77787,113.17264Z"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    id: "Label-2-3",
    "data-name": "Label-2",
    className: "cls-2",
    d: "M489.77787,121.68664h76.114a2.554,2.554,0,0,1,2.554,2.554h0a2.554,2.554,0,0,1-2.554,2.554h-76.114a2.554,2.554,0,0,1-2.554-2.554h0A2.554,2.554,0,0,1,489.77787,121.68664Z"
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    id: "Background-2-2",
    "data-name": "Background",
    className: "cls-2",
    cx: 626.30987,
    cy: 119.98364,
    r: 5.072
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    id: "Indicator-2-2",
    "data-name": "Indicator",
    className: "cls-2",
    cx: 626.30987,
    cy: 119.98364,
    r: 2.174
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    id: "Container-3-2",
    "data-name": "Container-3",
    className: "cls-4",
    d: "M483.60287,142.80664h157.232a2.9,2.9,0,0,1,2.9,2.9v22.46a2.9,2.9,0,0,1-2.9,2.9h-157.232a2.9,2.9,0,0,1-2.9-2.9v-22.46A2.9,2.9,0,0,1,483.60287,142.80664Z"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    id: "Label-3-2",
    "data-name": "Label-3",
    className: "cls-2",
    x: 487.22387,
    y: 151.28464,
    width: 121.005,
    height: 4.239,
    rx: 2.119
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    id: "Label-4-2",
    "data-name": "Label-4",
    className: "cls-2",
    x: 487.22387,
    y: 158.34964,
    width: 81.222,
    height: 4.239,
    rx: 2.119
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    id: "Background-2-3",
    "data-name": "Background-2",
    className: "cls-2",
    cx: 626.30987,
    cy: 156.93564,
    r: 5.072
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    id: "Indicator-2-3",
    "data-name": "Indicator-2",
    className: "cls-2",
    cx: 626.30987,
    cy: 156.93564,
    r: 2.174
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    id: "Container-4-2",
    "data-name": "Container-4",
    className: "cls-4",
    x: 480.70287,
    y: 176.86364,
    width: 163.03,
    height: 28.259,
    rx: 4
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    id: "Label-5-2",
    "data-name": "Label-5",
    className: "cls-2",
    x: 487.22387,
    y: 185.34164,
    width: 121.005,
    height: 4.239,
    rx: 2.119
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    id: "Label-6-2",
    "data-name": "Label-6",
    className: "cls-2",
    x: 487.22387,
    y: 192.40664,
    width: 81.222,
    height: 4.239,
    rx: 2.119
  })), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    id: "Background-3-2",
    "data-name": "Background-3",
    className: "cls-2",
    cx: 626.30987,
    cy: 190.99264,
    r: 5.072
  })), _circle18 || (_circle18 = /*#__PURE__*/React.createElement("circle", {
    id: "Indicator-3-2",
    "data-name": "Indicator-3",
    className: "cls-2",
    cx: 626.30987,
    cy: 190.99264,
    r: 2.174
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    id: "Container-5-2",
    "data-name": "Container-5",
    className: "cls-4",
    d: "M483.60287,279.02864h157.232a2.9,2.9,0,0,1,2.9,2.9v22.46a2.9,2.9,0,0,1-2.9,2.9h-157.232a2.9,2.9,0,0,1-2.9-2.9v-22.46A2.9,2.9,0,0,1,483.60287,279.02864Z"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    id: "Label-7-2",
    "data-name": "Label-7",
    className: "cls-2",
    x: 487.22387,
    y: 287.50664,
    width: 121.005,
    height: 4.239,
    rx: 2.119
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    id: "Label-8-2",
    "data-name": "Label-8",
    className: "cls-2",
    x: 487.22387,
    y: 294.57164,
    width: 81.222,
    height: 4.239,
    rx: 2.119
  })), _circle19 || (_circle19 = /*#__PURE__*/React.createElement("circle", {
    id: "Background-4-2",
    "data-name": "Background-4",
    className: "cls-2",
    cx: 626.30987,
    cy: 293.15764,
    r: 5.072
  })), _circle20 || (_circle20 = /*#__PURE__*/React.createElement("circle", {
    id: "Indicator-4-2",
    "data-name": "Indicator-4",
    className: "cls-2",
    cx: 626.30987,
    cy: 293.15764,
    r: 2.174
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    id: "Container-6-2",
    "data-name": "Container-6",
    className: "cls-4",
    x: 480.70287,
    y: 244.97163,
    width: 163.03,
    height: 28.259,
    rx: 4
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    id: "Label-9-2",
    "data-name": "Label-9",
    className: "cls-2",
    x: 487.22387,
    y: 253.44963,
    width: 121.005,
    height: 4.239,
    rx: 2.119
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    id: "Label-10-2",
    "data-name": "Label-10",
    className: "cls-2",
    x: 487.22387,
    y: 260.51463,
    width: 81.222,
    height: 4.239,
    rx: 2.119
  })), _circle21 || (_circle21 = /*#__PURE__*/React.createElement("circle", {
    id: "Background-5-2",
    "data-name": "Background-5",
    className: "cls-2",
    cx: 626.30987,
    cy: 259.10063,
    r: 5.072
  })), _circle22 || (_circle22 = /*#__PURE__*/React.createElement("circle", {
    id: "Indicator-5-2",
    "data-name": "Indicator-5",
    className: "cls-2",
    cx: 626.30987,
    cy: 259.10063,
    r: 2.174
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    id: "Container-7-2",
    "data-name": "Container-7",
    className: "cls-4",
    x: 480.70287,
    y: 210.91763,
    width: 163.03,
    height: 28.259,
    rx: 4
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    id: "Label-11-2",
    "data-name": "Label-11",
    className: "cls-2",
    x: 487.22387,
    y: 219.39563,
    width: 121.005,
    height: 4.239,
    rx: 2.119
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    id: "Label-12-2",
    "data-name": "Label-12",
    className: "cls-2",
    x: 487.22387,
    y: 226.46063,
    width: 81.222,
    height: 4.239,
    rx: 2.119
  })), _circle23 || (_circle23 = /*#__PURE__*/React.createElement("circle", {
    id: "Background-6-2",
    "data-name": "Background-6",
    className: "cls-2",
    cx: 626.30987,
    cy: 225.04663,
    r: 5.072
  })), _circle24 || (_circle24 = /*#__PURE__*/React.createElement("circle", {
    id: "Indicator-6-2",
    "data-name": "Indicator-6",
    className: "cls-2",
    cx: 626.30987,
    cy: 225.04663,
    r: 2.174
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    id: "Path_584-2",
    "data-name": "Path 584",
    className: "cls-5",
    d: "M596.87086,85.20464h-4.225v-.641h4.225Z"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    id: "Path_585-2",
    "data-name": "Path 585",
    className: "cls-5",
    d: "M581.89386,83.95564v-2.686h-1.791v2.686h-1.005v-6.056h1.005v2.455h1.791v-2.455h1.006v6.056Z"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    id: "Path_586-2",
    "data-name": "Path 586",
    className: "cls-5",
    d: "M590.93786,83.95564l-1.7-4.276h-.025l.017,4.276h-.912v-6.056h1.157l1.681,4.3h.025l-.008-4.3h.875v6.056Z"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    id: "Path_587-2",
    "data-name": "Path 587",
    className: "cls-5",
    d: "M586.32587,77.89964h-1.258l-1,4.064-.84.285.263.794.339-.115-.253,1.027h.921l.337-1.369,1.593-.541.47,1.91h.921Zm-1.255,3.723.6-2.418h.06l.5,2.025Z"
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    id: "Background-7-2",
    "data-name": "Background-7",
    className: "cls-4",
    x: 649.52986,
    y: 102.22964,
    width: 50.721,
    height: 58.691,
    rx: 8
  })), _circle25 || (_circle25 = /*#__PURE__*/React.createElement("circle", {
    id: "Avatar-2",
    "data-name": "Avatar",
    className: "cls-2",
    cx: 674.88986,
    cy: 124.69264,
    r: 11.593
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    id: "Name-2-2",
    "data-name": "Name",
    className: "cls-2",
    d: "M658.94987,139.18464h31.881a2.17376,2.17376,0,0,1,2.174,2.1735h0a2.17376,2.17376,0,0,1-2.174,2.1735h-31.881a2.17375,2.17375,0,0,1-2.174-2.1735h0A2.17375,2.17375,0,0,1,658.94987,139.18464Z"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    id: "Name-2-3",
    "data-name": "Name-2",
    className: "cls-2",
    d: "M664.74686,146.43064h20.288a2.17375,2.17375,0,0,1,2.174,2.1735h0a2.17375,2.17375,0,0,1-2.174,2.1735h-20.288a2.17376,2.17376,0,0,1-2.174-2.1735h0A2.17376,2.17376,0,0,1,664.74686,146.43064Z"
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    id: "Background-8-2",
    "data-name": "Background-8",
    className: "cls-4",
    x: 649.52986,
    y: 166.71864,
    width: 50.721,
    height: 140.56799,
    rx: 8
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    id: "Data-2-2",
    "data-name": "Data",
    className: "cls-2",
    x: 662.57286,
    y: 179.76164,
    width: 24.636,
    height: 18.839,
    rx: 4
  })), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    id: "Data-2-3",
    "data-name": "Data-2",
    className: "cls-2",
    x: 662.57286,
    y: 204.39764,
    width: 24.636,
    height: 18.114,
    rx: 4
  })), _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
    id: "Data-3-2",
    "data-name": "Data-3",
    className: "cls-2",
    x: 662.57286,
    y: 228.30864,
    width: 24.636,
    height: 18.114,
    rx: 4
  })), _rect34 || (_rect34 = /*#__PURE__*/React.createElement("rect", {
    id: "Data-4-2",
    "data-name": "Data-4",
    className: "cls-2",
    x: 662.57286,
    y: 276.13065,
    width: 24.636,
    height: 18.114,
    rx: 4
  })), _rect35 || (_rect35 = /*#__PURE__*/React.createElement("rect", {
    id: "Data-5-2",
    "data-name": "Data-5",
    className: "cls-2",
    x: 662.57286,
    y: 252.21964,
    width: 24.636,
    height: 18.114,
    rx: 4
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    id: "Path_589",
    "data-name": "Path 589",
    className: "cls-7",
    d: "M317.90582,80.52977v-42.408a30.29307,30.29307,0,0,0-30.271-30.25293h-92.803A30.278,30.278,0,0,0,164.5799,38.12181V291.50975a30.293,30.293,0,0,0,30.25195,30.271h92.8a30.30813,30.30813,0,0,0,30.271-30.271V119.62962a3.96089,3.96089,0,0,0,3.619-3.949V84.4597A3.94387,3.94387,0,0,0,317.90582,80.52977Zm-7.312,210.981a22.97593,22.97593,0,0,1-22.959,22.958h-92.803a22.97189,22.97189,0,0,1-22.93994-22.958V38.12181a22.968,22.968,0,0,1,22.93994-22.94092h3.9v4.82593a8.634,8.634,0,0,0,8.641,8.62695h67.748a8.62,8.62,0,0,0,8.62805-8.61206V15.18089h3.89295a22.97185,22.97185,0,0,1,22.959,22.94092Z"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    id: "Path_590",
    "data-name": "Path 590",
    className: "cls-2",
    d: "M310.59381,38.12083V291.50975a22.97594,22.97594,0,0,1-22.959,22.958h-92.806a22.9719,22.9719,0,0,1-22.93994-22.958V38.12083A22.96795,22.96795,0,0,1,194.8288,15.17992h3.9v4.82592a8.634,8.634,0,0,0,8.641,8.627h67.74805a8.62,8.62,0,0,0,8.628-8.61206V15.17992h3.893A22.97192,22.97192,0,0,1,310.59381,38.12083Z"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    id: "Path_591",
    "data-name": "Path 591",
    className: "cls-5",
    d: "M171.88788,266.85179V291.5117a22.9719,22.9719,0,0,0,22.93994,22.958h92.806a22.97591,22.97591,0,0,0,22.96-22.958V266.85277Z"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    id: "Path_592",
    "data-name": "Path 592",
    className: "cls-5",
    d: "M286.40082,157.16551h-90.335a7.435,7.435,0,0,0-7.434,7.436v47.51391a7.434,7.434,0,0,0,7.434,7.43408h81.217a6.78227,6.78227,0,0,1,4.82605,2.01612l8.394,8.48706a1.948,1.948,0,0,0,3.334-1.3689v-64.083a7.43512,7.43512,0,0,0-7.4347-7.4353Z"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    id: "Path_593",
    "data-name": "Path 593",
    className: "cls-5",
    d: "M196.06586,51.41356h90.335a7.43508,7.43508,0,0,1,7.436,7.43408v47.51587a7.435,7.435,0,0,1-7.43494,7.43506H205.18378a6.78932,6.78932,0,0,0-4.82605,2.01391l-8.392,8.489a1.949,1.949,0,0,1-3.33789-1.36987v-64.082a7.435,7.435,0,0,1,7.434-7.436Z"
  })), _rect36 || (_rect36 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2989",
    "data-name": "Rectangle 2989",
    className: "cls-3",
    x: 201.26787,
    y: 202.53363,
    width: 79.935,
    height: 1.874
  })), _rect37 || (_rect37 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2990",
    "data-name": "Rectangle 2990",
    className: "cls-3",
    x: 201.26787,
    y: 193.24763,
    width: 79.935,
    height: 1.874
  })), _rect38 || (_rect38 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2991",
    "data-name": "Rectangle 2991",
    className: "cls-3",
    x: 201.26787,
    y: 183.96664,
    width: 79.935,
    height: 1.874
  })), _rect39 || (_rect39 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2992",
    "data-name": "Rectangle 2992",
    className: "cls-3",
    x: 201.26787,
    y: 174.68164,
    width: 79.935,
    height: 1.874
  })), _rect40 || (_rect40 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2993",
    "data-name": "Rectangle 2993",
    className: "cls-3",
    x: 201.26487,
    y: 96.78164,
    width: 79.935,
    height: 1.874
  })), _rect41 || (_rect41 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2994",
    "data-name": "Rectangle 2994",
    className: "cls-3",
    x: 201.26487,
    y: 87.49564,
    width: 79.935,
    height: 1.874
  })), _rect42 || (_rect42 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2995",
    "data-name": "Rectangle 2995",
    className: "cls-3",
    x: 201.26487,
    y: 78.21464,
    width: 79.935,
    height: 1.874
  })), _rect43 || (_rect43 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2996",
    "data-name": "Rectangle 2996",
    className: "cls-3",
    x: 201.26487,
    y: 68.92964,
    width: 79.935,
    height: 1.874
  })), _rect44 || (_rect44 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2997",
    "data-name": "Rectangle 2997",
    className: "cls-2",
    x: 183.03487,
    y: 277.71864,
    width: 92.617,
    height: 17.508,
    rx: 2.104
  })), _circle26 || (_circle26 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_55",
    "data-name": "Ellipse 55",
    className: "cls-20",
    cx: 291.02087,
    cy: 286.80065,
    r: 8.426
  })), _rect45 || (_rect45 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2998",
    "data-name": "Rectangle 2998",
    className: "cls-21",
    x: 188.63087,
    y: 132.79163,
    width: 66.974,
    height: 8.721,
    rx: 2.386
  })), _rect46 || (_rect46 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2999",
    "data-name": "Rectangle 2999",
    className: "cls-22",
    x: 232.13787,
    y: 241.57764,
    width: 66.974,
    height: 8.721,
    rx: 2.386
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    id: "Leg",
    className: "cls-9",
    d: "M63.43487,136.90164l28.046,98.419,20.462,72.54h14.925l-21.745-170.959Z"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    id: "Leg-2",
    className: "cls-23",
    d: "M55.93487,136.90164c-.649,50.726-2.861,78.393-3.542,83s-10.98,33.93-30.896,87.958h15.461q38.032-77.747,42.461-87.958c2.952-6.8,12.064-34.471,25.789-83Z"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    id: "Shoe-2-2",
    "data-name": "Shoe",
    className: "cls-9",
    d: "M20.11587,321.78365l.774-16.245h16.244c11.555,8.122,30.17,13.151,30.17,13.151v3.094h-29.4l-10.052-1.545v1.547Z"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    id: "Shoe-2-3",
    "data-name": "Shoe-2",
    className: "cls-9",
    d: "M109.84887,321.78365l.774-16.245h16.244c11.555,8.122,30.17,13.151,30.17,13.151v3.094h-29.4l-10.052-1.545v1.547Z"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    id: "Neck",
    className: "cls-8",
    d: "M86.64187,57.99564l7.8-36.358h5.626l5.139,36.358Z"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    id: "Head",
    className: "cls-8",
    d: "M114.30387,39.63564c-5.789,1.491-28.007-9.931-26.845-26.486s24.206-12.913,28.689-4.557S120.09787,38.14164,114.30387,39.63564Z"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    id: "Path",
    className: "cls-9",
    d: "M108.14487,9.70264c-2.617,1.382-4.444,4.066-6.655,7.614a4.642,4.642,0,0,0-4.94,7.642c-1.074,1.516-2.278,3.1-3.657,4.733-5.182-3.108-9.027-12.208-3.961-20.95a11.462,11.462,0,0,1,8.314-7.632,13.46492,13.46492,0,0,1,8.837-.651c5.209.446,9.861,2.035,11.179,2.978,0,4.932-.956,6.395-9.118,6.266Z"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    id: "Beard",
    className: "cls-9",
    d: "M102.99187,14.97464s1.066,14.851,5.64,14.851,8.455-2.9,10.462-2.9c1.463,0,1.136,1.831.167,3.188-.8,1.12-4.7,2.2-4.7,3.936s3.078.393,3.078,1.423c0,1.7.541,4.906-2.415,4.906-2.992,0-11.57-1.09-13.04-5.531s-1.864-18.721-1.864-18.721Z"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    id: "Arm",
    className: "cls-8",
    d: "M151.62087,97.15064l28.03-12.31a66.42087,66.42087,0,0,1,14.224-11.156c1.367-.435,3.7-.567,1.211,3.074s-4.95,7.582-3.954,8.857,3.881-.132,5.02,1.942q1.14,2.075-14.589,4.964l-20.992,16.095Z"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    id: "Arm-2",
    className: "cls-8",
    d: "M38.30187,100.54464l15.85,3.145q-23.913,44.564-25.65,47.238c-2.6,4.011-.174,11.361.723,15.232-5.628,1.31-3.408-7.16-10.53-5.392-6.5,1.614-12.012,5.757-18.073.17-.745-.687-1.291-2.834,1.25-3.935,6.33-2.743,15.682-7.881,17.2-9.875Q22.17387,143.04464,38.30187,100.54464Z"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    id: "Coat_Back",
    "data-name": "Coat Back",
    className: "cls-13",
    d: "M97.23571,41.23873l6.6879-1.148c14.56855,14.12866,20.51731,48.07516,30.22516,52.56721,9.17827,4.24707,22.18911.13173,37.65371-5.41921L176.53969,97.818c-14.04983,15.20568-43.98341,28.05347-56.11792,20.723C101.02023,106.82134,96.53621,64.9529,97.23571,41.23873Z"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    id: "Shirt-2",
    "data-name": "Shirt",
    className: "cls-12",
    d: "M68.07686,125.29963h59.187c2.7,0,2.195-3.905,1.8-5.876-4.508-22.743-22.122-47.26-22.122-79.634l-17.072-2.677C75.74886,59.82364,70.86586,87.78464,68.07686,125.29963Z"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    id: "Clothes_Body",
    "data-name": "Clothes Body",
    className: "cls-13",
    d: "M54.92487,141.54464h53.277c10.314-26.065-12.677-104.432-12.677-104.432h-6.563C76.19787,59.88964,57.41887,103.91964,54.92487,141.54464Z"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    id: "Clothes_Front",
    "data-name": "Clothes Front",
    className: "cls-13",
    d: "M88.76787,37.11264h3.081l.981,5.361q-39.437,81.59-61.082,106.806l-12.406-2.43Q31.32887,72.51264,88.76787,37.11264Z"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    id: "Path_286",
    "data-name": "Path 286",
    className: "cls-24",
    d: "M343.10988,49.3857c1.6-.813,3.2-1.75,2.629-4.96-1.027-5.728-4.3-10.74292.887-15.678.638-.60595,2.53-.958,3.34,1.31006,2.016,5.645,5.933,14.0459,7.575,15.47608,2.24,1.947,1.3,2.69092,25.611,12.291l-8.209,8.61011c-18.832-10.811-19.757-11.842-21.235-12.94312-3.329-2.488-9.84-.8-13.246-.24609a4.14545,4.14545,0,0,1-.054-.96509C340.51288,50.62862,341.80889,50.04781,343.10988,49.3857Z"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    id: "Leg-3",
    className: "cls-7",
    d: "M438.96087,143.94163l-20.919,164.438h14.354l19.685-69.77491,26.977-94.668Z"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    id: "Leg-2-2",
    className: "cls-16",
    d: "M438.86687,143.94163c13.205,46.68091,15.834,79.83911,15.834,79.83911s3.453,31.71094,18.339,84.6001h14.877c-1.788-9.88306-3.217-19.19995-4.356-27.78492a312.37006,312.37006,0,0,1-.349-80.561,406.01,406.01,0,0,0,3.061-56.1001Z"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    id: "Shoe-3",
    d: "M481.80487,321.77863v-1.488l-9.673,1.48608h-28.276v-2.9729s17.906-4.83691,29.021-12.6499h15.624l.745,15.625Z"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    id: "Shoe-2-2",
    d: "M426.96988,321.77863v-1.488l-9.673,1.48608h-28.276v-2.9729s17.906-4.83691,29.021-12.6499h15.624l.745,15.625Z"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    id: "Head-2-2",
    className: "cls-24",
    d: "M438.87388,65.06755l3.025-21.3999c-4.819,2.8999-9.551,4.3059-11.775,3.73291-5.571-1.43409-6.082-21.8191-1.772-29.856s26.478-11.541,27.6,4.38305a20.16327,20.16327,0,0,1-5.362,14.48292l6.148,28.656Z"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    id: "Hair-2",
    "data-name": "Hair",
    className: "cls-25",
    d: "M441.00888,23.69161a14.46223,14.46223,0,0,0-4.958-5.073c-7.851.124-8.768-1.28393-8.768-6.0271,1.267-.90893,5.74-2.43505,10.752-2.86694a12.96856,12.96856,0,0,1,8.5.627,11.02584,11.02584,0,0,1,8,7.34009c4.871,8.40991,1.174,17.16406-3.812,20.15308-1.326-1.571-2.482-3.1001-3.516-4.554a4.46579,4.46579,0,0,0-3.11794-7.65918h-.00206a4.43514,4.43514,0,0,0-.534.032C442.95687,25.85665,441.82187,24.94064,441.00888,23.69161Z"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    id: "Path_287",
    "data-name": "Path 287",
    className: "cls-24",
    d: "M510.95587,131.03658l12.856,29.58594a70.05033,70.05033,0,0,1,11.695,15.033c.452,1.44409.582,3.8999-3.243,1.26294s-7.969-5.249-9.317-4.2.125,4.08911-2.068,5.281q-2.191,1.19494-5.17-15.39111l-16.872-22.18311Z"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    id: "Coat_Back-2",
    "data-name": "Coat Back-2",
    className: "cls-20",
    d: "M399.46787,77.87252c-13.6-.96606-20.913-2.376-42.515-19.61108l9.026-9.322a111.8713,111.8713,0,0,0,23.925,7.864,55.13484,55.13484,0,0,0,19.957.688c9.112-1.34595,20.289-3.1001,34.252-5.3l6.055,10.70508C437.56887,81.92745,409.23987,78.57857,399.46787,77.87252Z"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    id: "Shirt-2-2",
    "data-name": "Shirt-2",
    className: "cls-12",
    d: "M453.62888,47.9587l-16.422,2.574c0,31.14111-6.3,65.36108-10.643,87.23706-.376,1.8999-.867,5.6521,1.735,5.6521l45.346-2.82593C470.96288,104.50875,467.21188,69.79977,453.62888,47.9587Z"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    id: "Coat_Front-2",
    "data-name": "Coat Front",
    className: "cls-20",
    d: "M509.53787,155.84982q-11.859-13.81312-29.269-45.218a187.0567,187.0567,0,0,1,6.973,37.7771h-51.247c-9.92-25.072,12.187-100.45313,12.187-100.45313h6.507c36.834,22.7,43.816,49.709,66.782,105.554Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIllustratieContact);
export default __webpack_public_path__ + "static/media/illustratie_contact.b308a0d32f94cdd1bf2a8df6be3c0f61.svg";
export { ForwardRef as ReactComponent };